// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jHbp","option":"styles_option__snEOa","selected":"styles_selected__1OwnL"};